<template>
    <div>
        <div class="container mx-auto home__courses__list">
            <div class="home__courses__list__items position-relative py-4 flex flex-wrap justify-center" v-if="courses">
                <div v-for="(course, index) in courses" :key="index" class="w-full p-2"
                :class="{
                    'md:w-1/3': courses.length > 2 && !course.banner,
                    'md:w-1/2': courses.length == 2 && !course.banner,
                }">
                    <course-group-card :item="course" :theme-store="ThemeStore" @group-updated="groupUpdated" v-if="!course.banner"/>
                    <banner-card :item="course" :theme-store="ThemeStore" v-else/>
                </div>
            </div>
        </div>
        <div class="container mx-auto my-6" v-if="pagesCount > 1">
            <courses-pagination :pages="pagesCount" :current="currentPage" @page-updated="fetch"/>
        </div>
    </div>
</template>

<script>
import ModulesList from '@/components/Modules/Index.vue'
import CourseGroupCard from './Card.vue';
import BannerCard from '@/components/Banner/Card.vue'
import CoursesPagination from '@/components/Partials/CoursesPagination.vue'
import { useThemeStore } from "@/store/ThemeStore";

import AuthMixin from '@/mixins/authMixin'
import UIMixin from '@/mixins/uiMixin'

export default {
    mixins: [AuthMixin, UIMixin],
    components: {
        CoursesPagination,
        CourseGroupCard,
        BannerCard,
        ModulesList,
    },
    props: {
        filter: String,
    },
    data () {
        const ThemeStore = useThemeStore();
        return {
            ThemeStore: ThemeStore,
            thematicRefs: null,
            fetching: false,
            course: {},
            courses: [],
            coursesCount: 0,
            coursesPerPage: 0,
            currentPage: 0,
            pagesCount: 0,
        }
    },
    mounted() {
        this.fetch()
    },
    watch: {
        filter() {
            this.fetch()
        }
    },
    methods: {
        groupUpdated(group, showTitle) {
            this.$emit('group-updated', {
                ref: group.ref,
                name: group.name,
                showTitle: showTitle
            })
        },
        fetch(page) {
            this.thematicRefs = this.filter;

            const url = process.env.VUE_APP_BASE_URL + '/data/Scorm/Courses'
            const accessToken = this.$cookies.get('access_token')
            this.fetching = true

            const headers = {
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: 'Bearer ' + accessToken
            }

            if (!this.thematicRefs)
            {
                switch (this.ThemeStore.client) {
                  case 'rh':
                  case 'auxpros':
                  case 'aapp':
                    this.thematicRefs = 'aapp'
                    break
                  default:
                    this.thematicRefs = "default"
                    break
                }
            }

            this.$http.get(url, { headers: headers, params: {
            lang: 'fr',
            modulesPerPage: 6,
            thematicRefs: this.thematicRefs,
            client: this.ThemeStore.client,
            page: page ?? 1
            } }).then(
                res => {
                    // detect if we get an array of parcours or a single parcours
                    if (res.data.courses) { // array of parcours
                        // count courses if we get only 1 we call directly the modules listing
                        if (res.data.coursesCount == 1) {
                            this.groupUpdated(res.data.courses[0], false)
                            return
                        }

                        this.courses = res.data.courses
                        this.coursesCount = res.data.coursesCount
                        this.coursesPerPage = res.data.coursesPerPage
                        this.currentPage = res.data.currentPage
                        this.pagesCount = res.data.pagesCount
                    } else { // single parcours
                        this.currentParcours = res.data[0]
                        this.uniqueParcours = true
                    }
                    
                    this.fetching = false
                },
                error => {
                    this.fetching = false

                    switch (error.response.status) {
                        case 401:
                            this.refreshToken(() => {
                                this.fetch(page)
                            })
                            
                            return
                        case 503:
                            this.$router.push({ name: 'maintenance.index' })
                            break
                        default:
                            break
                    }
                }
            )
        },
    }
}
</script>
